export const DonationManagentList = [
  {
    id: '1',
    value: {
      de: 'alle deine Spenden zu sehen',
      en: 'see all your donations',
    },
  },
  {
    id: '2',
    value: {
      de: 'deine Wildnispatenschafts-Urkunden zu downloaden',
      en: 'download your wilderness protection certificates',
    },
  },
  {
    id: '3',
    value: {
      de: 'Spendenbescheinigungen zu erstellen',
      en: 'generate donation receipts',
    },
  },
  {
    id: '4',
    value: {
      de: 'Dauerspenden zu ändern',
      en: 'change recurring donations',
    },
  },
];
